export const KPI_CHART_COLORS = Object.freeze({
  exposureCount: "#f5811f",
  costAmount: "#4f7fd6",
  cpv: "#2fae8f",
  ecpm: "#2fae8f",
  allowInventorys: "#7668dc",
  inventoryCount: "#7668dc"
});

export const getKpiChartColor = (metric, fallback = "#8b929a") =>
    KPI_CHART_COLORS[metric] ?? fallback;
